import React from "react";
import { TokenTableRowSkeleton } from "./TokenTableRowSkeleton";
import styles from "./TokensTable.module.scss";
import tableColStyles from "./TableColumns.module.scss";

const SKELETON_ROWS = 25;

export const TableSkeleton: React.FC = () => (
  <div className={styles.table} aria-busy="true" aria-live="polite">
    {/* Table header */}
    <div className={styles.header}>
      <div className={[styles.cell, tableColStyles.tableCol, tableColStyles.tableColToken].join(" ")}>Token</div>
      <div className={[styles.cell, tableColStyles.tableCol, tableColStyles.tableColPrice].join(" ")}>Price</div>
      <div className={[styles.cell, tableColStyles.tableCol, tableColStyles.tableColMarketCap].join(" ")}>Market Cap</div>
      <div className={[styles.cell, tableColStyles.tableCol, tableColStyles.tableColLiquidity].join(" ")}>Liquidity</div>
      <div className={[styles.cell, tableColStyles.tableCol, tableColStyles.tableColVolume].join(" ")}>Volume 24h</div>
      <div className={[styles.cell, tableColStyles.tableCol, tableColStyles.tableColBuy].join(" ")}></div>
    </div>
    {/* Skeleton rows */}
    {Array.from({ length: SKELETON_ROWS }).map((_, i) => (
      <TokenTableRowSkeleton key={i} />
    ))}
  </div>
);

export default TableSkeleton;
